import Vue from "vue";
import App from "./App.vue";
// 导入vant
import Vant, { Locale } from "vant";
// 引入组件库
import VueEasytable from "vue-easytable";

// 导入 Vant 语言包
import zhCN from "vant/es/locale/lang/zh-CN";
import enUS from "vant/es/locale/lang/en-US";
import viVN from "vant/es/locale/lang/vi-VN";
// 注意：Vant 暂不支持马来语，将使用英文包替代

// import zhCN from "./i18n/config/zh.js";
// import enUS from "./i18n/config/en.js";
// 导入路由
import router from "./router/index";
// 导入vuex
import store from "./store/index";
// 移动端适配
import "lib-flexible";
// import 'amfe-flexible'
// import JSBridge from "./utils/JSBridge.js";
// Vue.prototype.bridge = JSBridge;
import moment from "moment";
import _ from "lodash";
// 全局样式
import "vant/lib/index.css";
import "vue-easytable/libs/theme-default/index.css";
import "./assets/style/variable.scss";
import "./assets/iconfont/iconfont.css";
import "./assets/style/index.scss";
// import VConsole from 'vconsole'
// i18n多语言
import i18n from "./i18n";

Vue.config.productionTip = false;

Vue.prototype.$moment = moment;
Vue.prototype.$lodash = _;

Vue.use(Vant);

// 根据当前语言设置 Vant 的 Locale
const setVantLocale = (lang) => {
  switch (lang) {
    case 'en':
      Locale.use('en-US', enUS);
      break;
    case 'ms':
      Locale.use('en-US', enUS); // 马来语暂时使用英文包
      break;
    case 'vi':
      Locale.use('vi-VN', viVN);
      break;
    case 'zh-TW':
      Locale.use('zh-CN', zhCN); // 繁体中文暂时使用简体中文包
      break;
    case 'in':
    case 'id':
      Locale.use('en-US', enUS); // 印尼语暂时使用英文包
      break;
    case 'th':
      Locale.use('en-US', enUS); // 泰国语暂时使用英文包（Vant 无泰语包）
      break;
    default:
      Locale.use('zh-CN', zhCN);
      break;
  }
};

// 初始化语言设置
setVantLocale(i18n.locale);

// 监听语言变化
i18n.vm.$watch('locale', (newLocale) => {
  setVantLocale(newLocale);
});

Vue.use(VueEasytable);

// new VConsole();

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
